module.exports = __webpack_public_path__ + "static/media/week8.39ce44a9.jpg";